var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { UserService } from '@app/user.service';
import { ActivatedRoute, Router } from '@angular/router';
var ResetPasswordComponent = /** @class */ (function () {
    function ResetPasswordComponent(Api, Util, UserService, Route, Router) {
        var _this = this;
        this.Api = Api;
        this.Util = Util;
        this.UserService = UserService;
        this.Route = Route;
        this.Router = Router;
        this.Route.queryParams.subscribe(function (Params) {
            _this.TokenID = Params["id"];
        });
    }
    ResetPasswordComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.Util.ShowWaiting(true);
                        if (!(this.TokenID == null || this.TokenID == "")) return [3 /*break*/, 1];
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, this.GetToken()];
                    case 2:
                        _a.Token = _b.sent();
                        if (this.Token == null) {
                            this.Util.ErrorDialog("Invalid token.");
                            $("#Save").attr("disabled", "disabled");
                        }
                        else {
                            //await this.DeleteToken(this.TokenID);
                        }
                        _b.label = 3;
                    case 3:
                        this.Util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    ResetPasswordComponent.prototype.GetToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.Api.getPortal("User", "GetToken", "token_id=" + this.TokenID)];
                    case 1:
                        Res = _a.sent();
                        if (Res != null) {
                            return [2 /*return*/, Res.token_id];
                        }
                        return [2 /*return*/, Res];
                }
            });
        });
    };
    ResetPasswordComponent.prototype.DeleteToken = function (TokenID) {
        return __awaiter(this, void 0, void 0, function () {
            var ParamObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ParamObj = {
                            token_id: TokenID
                        };
                        return [4 /*yield*/, this.Api.postPortal("user", "deletetoken", ParamObj)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ResetPasswordComponent.prototype.Save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var NewPwd, ConfirmPwd, ParamObj, Res, ThisTs, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        NewPwd = $('#NewPassword').val();
                        ConfirmPwd = $('#ConfirmPassword').val();
                        if (NewPwd == "") {
                            $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่');
                            return [2 /*return*/];
                        }
                        if (!this.UserService.IsValidatePassword(NewPwd)) {
                            $('#lblPwdError').html('**รหัสผ่านใหม่ไม่ตรงตามข้อกำหนด');
                            return [2 /*return*/];
                        }
                        if (NewPwd != ConfirmPwd) {
                            $('#lblPwdError').html('**กรุณายืนยันรหัสผ่านให้ตรงกัน');
                            return [2 /*return*/];
                        }
                        this.Util.ShowWaiting(true);
                        ParamObj = {
                            //username: this.Token.username, 
                            newpassword: NewPwd,
                            token_id: this.TokenID
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.Api.postPortal("user", "resetpassword", ParamObj)];
                    case 2:
                        Res = _a.sent();
                        if (Res.code == "200") {
                            this.Util.ShowWaiting(false);
                            this.Util.SuccessDialog("เปลี่ยนรหัสผ่านสำเร็จ");
                            ThisTs = this;
                            $("#btnSuccessOK").off('click');
                            $("#btnSuccessOK").click(function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    var Url;
                                    return __generator(this, function (_a) {
                                        Url = window.location.origin + "/mainmenu/login";
                                        window.location.href = Url;
                                        return [2 /*return*/];
                                    });
                                });
                            });
                        }
                        else {
                            this.Util.WarningDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        this.Util.WarningDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
                        return [3 /*break*/, 4];
                    case 4:
                        this.Util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    return ResetPasswordComponent;
}());
export { ResetPasswordComponent };



// WEBPACK FOOTER //
// ./src/app/account/reset-password/reset-password.component.ts.pre-build-optimizer.js